export default __webpack_public_path__ + "static/media/about5.140b066f.jpeg";